import React, { useContext, useEffect, useState } from 'react';

import CardArrow from '../../../Cards/CardArrow/CardArrow';
import { ReactComponent as PSE } from '../../../../assets/icons/PSE.svg';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/PlusIcon.svg';
import useGet from '../../../../services/hooks/http/useGet';
import Button from '../../../Buttons/Button/Button';
import Context from '../../../../store/context';
import { documentTypesAbbreviationsObject } from '../../../../store/catalogs/documentTypes';
import AddPSEAccount from './AddPSEAccount/AddPSEAccount';
import useFetch from '../../../../services/hooks/http/useFetch';
import apiMethods from '../../../../apis';
import Radio from '../../../inputs/Radios/Radio/Radio';
import DeletePSEAccount from './DeletePSEAccount/DeletePSEAccount';

import classes from './CardPSEPay.module.scss';

const CardPSEPay = ({ open, setShowMethodPay, businessId, setPseAccountSelected, pseAccountSelected }) => {
  const [isNotFirstFetchForPSE, setIsNotFirstFetchForPSE] = useState(true);

  const {
    data: updatedBusinessData,
    isSuccess: updateSuccess,
    sendRequest: updateBusiness,
    isError: updateError,
    errorMessage: errorMessageUpdate
  } = useFetch(apiMethods.updateBusiness);
  const {
    data: deletePSEAccountData,
    isSuccess: deletePSEAccountSuccess,
    sendRequest: deletePSEAccount,
    isError: deletePSEAccountError,
    errorMessage: errorMessageDeletePSEAccount
  } = useFetch(apiMethods.deletePSEAccount);

  const {
    isSuccess: getBusinessSuccess,
    data: getBusinessData,
    isError: getBusinessError,
    errorMessage
  } = useGet(apiMethods.getBusiness, [businessId], isNotFirstFetchForPSE && open);

  const {
    isSuccess: getPseBanksSuccess,
    data: getPseBanksData,
    isError: getPseBanksError,
    errorMessage: errorPseBanksMessage
  } = useGet(apiMethods.getPseBanks, [businessId], isNotFirstFetchForPSE && open);

  const [accountsPSE, setAccountsPSE] = useState([]);
  const [pseBanks, setPseBanks] = useState([]);

  const {
    modal: { showModal, showError, hideModal },
    toast: { showSuccess }
  } = useContext(Context);

  useEffect(() => {
    if (getPseBanksSuccess) {
      //setPseBanks(getPseBanksData?.data?.bankList.map(({ code, name }) => ({ value: code, label: name })));
      setPseBanks(getPseBanksData.map(({ code, name }) => ({ value: code, label: name })));
    } else if (getPseBanksError) {
      showError({ title: 'Bancos PSE', description: errorPseBanksMessage });
    }
  }, [errorPseBanksMessage, getPseBanksData, getPseBanksError, getPseBanksSuccess, showError]);

  useEffect(() => {
    if (getBusinessSuccess && open) {
      setAccountsPSE(
        !!getBusinessData.pseCustomers
          ? getBusinessData.pseCustomers.map(pseAccount => ({
              ...pseAccount,
              identification: `${documentTypesAbbreviationsObject[pseAccount.identificationType]} ${pseAccount.identificationNumber}`,
              bankId: 'PSE'
            }))
          : []
      );
      setIsNotFirstFetchForPSE(false);
    } else if (getBusinessError) {
      showError({ title: 'Cuentas PSE', description: errorMessage });
    }
  }, [errorMessage, open, getBusinessData, getBusinessError, getBusinessSuccess, showError]);

  const onAccept = values => {
    updateBusiness(businessId, {
      newPSECustomer: {
        ...values
      }
    });
  };

  useEffect(() => {
    if (updateSuccess) {
      hideModal();
      showSuccess('Cuenta creada con exito');
      setAccountsPSE(
        !!updatedBusinessData.pseCustomers
          ? updatedBusinessData.pseCustomers.map(pseAccount => ({
              ...pseAccount,
              identification: `${documentTypesAbbreviationsObject[pseAccount.identificationType]} ${pseAccount.identificationNumber}`,
              bankId: 'PSE'
            }))
          : []
      );
    } else if (updateError) {
      showError({ title: 'Agregar cuenta PSE', description: errorMessageUpdate });
    }
  }, [hideModal, errorMessageUpdate, showError, showSuccess, updateError, updateSuccess, updatedBusinessData]);

  const addPSEAccount = () => {
    showModal(<AddPSEAccount onAccept={onAccept} pseBanks={pseBanks} />, false);
  };

  const onClickDelete = value => {
    deletePSEAccount(businessId, [value]);
  };

  useEffect(() => {
    if (deletePSEAccountSuccess) {
      hideModal();
      showSuccess('Cuenta eliminada con exito');
      setPseAccountSelected(null);
      setAccountsPSE(
        !!deletePSEAccountData.pseCustomers
          ? deletePSEAccountData.pseCustomers.map(pseAccount => ({
              ...pseAccount,
              identification: `${documentTypesAbbreviationsObject[pseAccount.identificationType]} ${pseAccount.identificationNumber}`,
              bankId: 'PSE'
            }))
          : []
      );
    } else if (deletePSEAccountError) {
      showError({ title: 'Eliminar cuenta PSE', description: errorMessageDeletePSEAccount });
    }
  }, [
    setPseAccountSelected,
    hideModal,
    deletePSEAccountData,
    deletePSEAccountError,
    deletePSEAccountSuccess,
    errorMessageDeletePSEAccount,
    showError,
    showSuccess
  ]);

  const showDetailsPSE = (account, idx) => {
    showModal(<DeletePSEAccount pseBanks={pseBanks} onClickDelete={() => onClickDelete(idx)} account={account} />);
  };

  const setSelectedAccount = (index, account) => {
    setPseAccountSelected({ pseCustomerIndex: index, ...account });
  };

  const setShow = () => {
    setPseAccountSelected(null);
    setShowMethodPay('PSEPay');
  };

  return (
    <CardArrow
      Icon={PSE}
      title='Paga con PSE.'
      description='Realiza pagos desde cualquier banco al instante.'
      open={open}
      onClick={setShow}>
      {accountsPSE.length === 0 ? (
        <div className={classes.empty}>
          <span className={`medium-16 ${classes.text}`}>
            Aún no tienes cuentas guardadas de PSE Agrega una cuenta para realizar el pago.
          </span>
          <Button onClick={addPSEAccount} Icon={PlusIcon}>
            Agregar cuenta PSE
          </Button>
        </div>
      ) : (
        <div className={classes.content}>
          <span className='semibold-16'>¿Desde cuál cuenta quieres pagar?</span>
          <div className={classes.accounts}>
            <div className={classes.button}>
              <Button onClick={addPSEAccount} Icon={PlusIcon} custom='quaternary'>
                Agregar cuenta
              </Button>
            </div>
            {accountsPSE.map((account, idx) => (
              <div key={account.belvoPSECustomerId} className={classes.account}>
                <Radio
                  key={idx}
                  id={idx}
                  value={pseAccountSelected?.pseCustomerIndex}
                  onChange={() => setSelectedAccount(idx, account)}
                />
                <div className={classes.card}>
                  <div className={classes.text}>
                    <span className='medium-16'>{account.name}</span>
                    <span className='medium-16'>
                      {documentTypesAbbreviationsObject[account.identificationType]} {account.identificationNumber}
                    </span>
                  </div>
                  <Button onClick={() => showDetailsPSE(account, idx)} custom='quaternary'>
                    Ver detalles
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </CardArrow>
  );
};

export default CardPSEPay;
